import { type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type Psychologist } from '@avanta/shared/types/psychologists';

const PSYCHOLOGIST_URL = `${BASE_URL}psychologists`;
export interface PsychologistServiceTypes {
  getPsychologist: (psychologistId: string) => Promise<AxiosResponse<Psychologist>>;
}

export const PsychologistService: PsychologistServiceTypes = {
  getPsychologist: async psychologistId => service.get(`${PSYCHOLOGIST_URL}/${psychologistId}`),
};
